import React, { useState } from 'react';

// components
import MomtheraEducation from './MomtheraEducation';
import MomtheraMessage from './MomtheraMessage';


function MomtheraPatientReport({patientData, emotionData, depressionData, anxietyData}) {
	const [selectedTag, setSelectedTag] = useState("education");
	const reportTag = [
		{
			key: 'education',
			value: '교육 현황',
			component: <MomtheraEducation
							patientData={patientData}
							emotionData={emotionData}
							depressionData={depressionData}
							anxietyData={anxietyData}
						/>
		},
		{ key: 'message', value: '메시지 이력', component: <MomtheraMessage/> }
	];

	return (
		<div className="patientManageDetail__report">
			<div className="reportTag">
				{reportTag.map((item) => {
					return (
						<div
							key={item.key}
							className="reportTagItem"
							role="none"
							onClick={() => setSelectedTag(item.key)}
							style={{
								background: selectedTag === item.key ? '#aed0db' : 'white',
								border: selectedTag === item.key ? '0.5px solid transparent' : '0.5px solid #174a84',
							}}
						>
							{item.value}
						</div>
					);
				})}
			</div>
			<div className="reportContent momthera">
				<div className="reportContent__patientResult">
					{reportTag.filter(e=>e.key===selectedTag)[0].component}
				</div>			
			</div>
		</div>
	);
}

export default MomtheraPatientReport;
